export enum PeriodType {
    Daily,
    Weekly,
    Monthly,
    Quarterly,
    Yearly,
    PlanPeriod
}
